import React from 'react';
import '../styles.scss';
import { IContextMenuItem } from '../../interfaces/ContextMenu';
import ContextSubMenu from '../ContextSubMenu';
import TsrSvgIcon from '../../../assets/icons';
import { CONTEXT_MENU_MAX_WIDTH } from '..';
import TsrTooltip from '../../../tooltip';
import { letterWidth } from '../../../consts/letterConsts';

export function ContextMenuItem(props: IContextMenuItem) {
    const { label, shortcutLabel, onItemClick, onCloseMenu, hasSeparator, subMenu, iconName, disabled } = props;

    const clickItem = () => {
        !disabled && onItemClick && onItemClick();
        !disabled && !subMenu && onCloseMenu && onCloseMenu();
    };

    const renderTooltip = label.length * letterWidth > CONTEXT_MENU_MAX_WIDTH ? true : false;
    return (
        <>
            {subMenu && !disabled ? (
                <ContextSubMenu items={subMenu} isSubMenu={true}>
                    <li
                        className={'context-menu-item ' + (hasSeparator ? 'separator ' : '') + (disabled ? 'disabled ' : '')}
                        onClick={clickItem}
                    >
                        {props.subMenuLeftArrow ? (
                            <span className="context-menu-label">
                                {subMenu ? <TsrSvgIcon icon="arrowPrevious" /> : shortcutLabel}
                                {renderTooltip ? (
                                    <TsrTooltip content={label}>
                                        <>{label}</>
                                    </TsrTooltip>
                                ) : (
                                    label
                                )}
                            </span>
                        ) : (
                            <>
                                <span className="context-menu-label">
                                    {<TsrSvgIcon icon={iconName} />}
                                    {renderTooltip ? (
                                        <TsrTooltip content={label}>
                                            <>{label}</>
                                        </TsrTooltip>
                                    ) : (
                                        label
                                    )}
                                </span>
                                <span className="context-menu-shortcutLabel">
                                    {subMenu ? <TsrSvgIcon icon="arrowNext" /> : shortcutLabel}
                                </span>
                            </>
                        )}
                    </li>
                </ContextSubMenu>
            ) : (
                <li
                    className={'context-menu-item ' + (hasSeparator ? 'separator ' : '') + (disabled ? 'disabled ' : '')}
                    onClick={clickItem}
                >
                    <span className="context-menu-label">
                        {<TsrSvgIcon icon={iconName} />}
                        {renderTooltip ? (
                            <TsrTooltip content={label}>
                                <>{label}</>
                            </TsrTooltip>
                        ) : (
                            label
                        )}
                    </span>
                    <span className="context-menu-shortcutLabel">{subMenu ? <TsrSvgIcon icon="" /> : shortcutLabel}</span>
                </li>
            )}
        </>
    );
}
